<section class="widget-section">
  <div class="container-fluid" #heroZoneInfoBoxContainer>
    <app-infobox-zone appMarkComponentVisited area="Hero" [appHideParentIfEmpty]="heroZoneInfoBoxContainer"></app-infobox-zone>
  </div>
</section>

<section class="widget-section order-1" id="app-featured-news">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6 compact-mobile-padding">
    <app-news-layout></app-news-layout>
  </div>
</section>
<section class="widget-section order-2" id="app-my-news">
  <div class="border-top border-bottom border-grey-color" #filterByDepartmentContainer>
    <div class="container pt-3 pb-3 pt-lg-3 pb-lg-3">
      <app-filter-by-department appMarkComponentVisited [appHideParentIfEmpty]="filterByDepartmentContainer"></app-filter-by-department>
    </div>
  </div>
</section>
<section class="widget-section order-3">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6"  *ngIf="!hideCompactSectionComponent">
    <app-compact-layout (hideCompactSection)="hideCompactSection($event)"></app-compact-layout>
  </div>
</section>
<section class="widget-section order-4" id="info-box">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6  pl-0 pr-0" #infoBoxContainer>
    <app-infobox-zone appMarkComponentVisited area="Default" [appHideParentIfEmpty]="infoBoxContainer"></app-infobox-zone>
  </div>
</section>

<section class="widget-section order-5" id="app-power-bi">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6  pl-0 pr-0" #powerBIFramesContainer>
    <app-power-bi appMarkComponentVisited [appHideParentIfEmpty]="powerBIFramesContainer"></app-power-bi>
  </div>
</section>

<section class="widget-section order-6" id="app-kpi-charts">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6  pl-0 pr-0" #kpiContainer>
    <app-kpi-charts [appHideParentIfEmpty]="kpiContainer"></app-kpi-charts>
  </div>
</section>



